const permissions = {
  user: {
    create: {
      ownCompany: ["manager"],
      ownProject: ["project_admin"],
    },
    edit: {
      ownCompany: ["project_admin", "manager"],
    },
    update: {
      ownProject: ["project_admin"],
    },
  },
  group: {
    create: ["project_admin", "manager"],
    edit: ["project_admin", "manager"],
    update: ["project_admin"],
  },
  formTemplate: {
    create: ["project_admin", "manager", "form_admin"],
    edit: ["project_admin", "manager", "form_admin"],
  },
  form: {
    create: ["project_admin", "manager", "form_admin", "form_user"],
    edit: ["project_admin", "manager", "form_admin", "form_user"],
    update: ["project_admin"],
  },
  task: {
    create: ["project_admin", "manager", "form_admin", "form_user"],
    cancel: [],
    delegate: ["project_admin", "manager", "form_admin", "form_user"],
  },
  project: {
    create: ["project_admin"],
    delete: [],
  },
  projectSetting: {
    edit: ["project_admin"],
  },
  workflow: {
    create: ["manager", "form_admin", "project_admin", "form_user"],
    read: ["manager", "form_admin", "project_admin", "form_user"],
  },
  company: {
    create: ["admin", "project_admin", "manager"],
    edit: ["admin", "project_admin", "manager"],
    update: ["project_admin"],
  },
};

export default permissions;
